module.exports = __webpack_public_path__ + "img/icon-empty-state-bee.ec4f9c09.svg";